import React, { Component } from "react";
import { connect } from "react-redux";
import { logger } from "../../helper/Logger";
import { IConfigProps, IRootState } from "../../interfaces";
import { AppRoutes } from "../../config";
import { ImageURL } from "../../config";
import { FrontendUrl, getEnvValue } from "../../config";
import { configReducer } from "../../reducer/Configuration";
import { Block } from "@material-ui/icons";
import closeIcon from "../../assets/images/Close.png";



interface menus {
  path: any;
  name: any;
  id: any;
  src: any;
}

class MobileSidebar extends Component<any> {
  state = {
    showResourcesOptions: false,
    backgroundColorResourceItem: "none",
    //menuItems: menuItems
  };
  changeLeftSpace = ()  => { 
    if(this.props.location.pathname.indexOf("profile")  !== -1) {
      var elements = document.getElementsByClassName("main-section");
      for(var i=0;i<elements.length; i++) {
        elements[i].setAttribute("style","padding-left:200px"); 
      }
    } else {
      if(this.props.location.pathname.indexOf("/quiz")  !== -1) {
        var element = document.getElementById("review-questions");
        var element2 = document.getElementById("quiz-section");
        var style = element?.getAttribute("style");
        var style2 = element2?.getAttribute("style");
        if(style === 'display: none;' || style === 'display:none') { 
          document.getElementById("review-questions")?.setAttribute("style","display:none"); 
          document.getElementById("quiz-section")?.setAttribute("style","display:block");  
          document.getElementById("quiz-section")?.classList.add("addPaddingLeft");
        }
        else if(style === 'display:block') {
           document.getElementById("review-questions")?.setAttribute("style","display:block"); 
        document.getElementById("quiz-section")?.setAttribute("style","display:none"); 
        document.getElementById("review-questions")?.classList.add("addPaddingLeft");}

      } else {
      document.getElementById("right-container")?.setAttribute("style","padding-left:210px"); 
      }
    }
  }
  normalLeftSpace = ()  => {

    if(this.props.location.pathname.indexOf("profile") !== -1) {
      var elements = document.getElementsByClassName("main-section");
      for(var i=0;i<elements.length; i++) {
        elements[i].removeAttribute("style")
      }
    } else {
      if(this.props.location.pathname.indexOf("/quiz")  !== -1) {
        var element = document.getElementById("review-questions");
        var element2 = document.getElementById("quiz-section");
        var style = element?.getAttribute("style");
        var style2 = element2?.getAttribute("style");
        if(style === 'display: none;' || style === 'display:none') { 
          document.getElementById("review-questions")?.setAttribute("style","display:none"); 
          document.getElementById("quiz-section")?.setAttribute("style","display:block");  
          document.getElementById("quiz-section")?.classList.remove("addPaddingLeft");
      }
        else if(style === 'display:block') {
           document.getElementById("review-questions")?.setAttribute("style","display:block"); 
        document.getElementById("quiz-section")?.setAttribute("style","display:none"); 
        document.getElementById("review-questions")?.classList.remove("addPaddingLeft");
      }

      } else {
        document.getElementById("right-container")?.removeAttribute("style"); 
        }
    }
  }
  highlightMenu = (divId: any) => {
    var highlight = document.getElementById(divId);
    if( highlight) {
      highlight.style.textDecoration = "underline";
    }
  }
  deHighlightMenu = (divId: any) => {
    var deHighlight = document.getElementById(divId);
    if( deHighlight) {
      deHighlight.style.textDecoration = "";
    }
  }
  closeIcon = () => {
    document.getElementById("mobile-menu-hover-info")?.setAttribute("style","display:none");
    document.querySelector('.full-app-wrap')?.classList.remove("modal-container"); 
  }  

  redirectToPage = (path: any) => {    
    if(path == "quiz") {
      this.props.history.push({
        pathname: AppRoutes.START_QUIZ,
        state: {
          defaultActiveKey: "notStartedCourses",
        },
      })
    } else if(path == "editProfile") {
      this.props.history.push(AppRoutes.MY_ACCOUNT);
    } else if(path == "resources") {
      this.setState({
        showResourcesOptions: !this.state.showResourcesOptions,
      });
      this.props.history.push({
        pathname: AppRoutes.RESOURCES,
        state: {
          defaultActiveKey: "notStartedCourses",
        },
      });
    } else {
      window.location.href = "/student"+path;
    }
  }
  componentDidUpdate = (prevProps: IConfigProps) => {
    if(document.getElementById("menu-hover-info")) {    
      let matches = document.querySelectorAll("div#menu-hover-info div.ITEMS_CONTAINER div.cursor-pointer div.profile-text img.menu_item");
      if(matches.length === 6) { 
        matches.forEach((ImgItem, index) => {
          if(index ===2)
          ImgItem.setAttribute("height","20px");
        });
      }
     
     }
    const { configReducer } = this.props;
    if (
      prevProps.configReducer &&
      configReducer &&
      configReducer.isLoading !== prevProps.configReducer.isLoading
    ) {
      this.setState({
        configInfo: configReducer.configInfo
      });
    }
  };

  createMenus(permissions: any, isMObile: any) {
    const { configInfo } = permissions;
    var str;
    //console.log("permi",configInfo);
    if(configInfo) { 
      //console.log("Objj--",typeof(configInfo));
      Object.keys(configInfo).map((key) => {
        //console.log("config env--",configInfo.environment);
        if(configInfo.value && configInfo.name === 'portalMenus') {

          let leftmenuItems: menus[];          

          leftmenuItems = JSON.parse(configInfo.value);
//maxWidth: "165px",
          str = leftmenuItems.map((item: any, index: any) => (
            item.environment.split(",").includes(getEnvValue()) ?
            <div  style={{   display: "flex",
            alignItems: "center"}}            
            onClick={() => this.redirectToPage(item.path)}
            className={`cursor-pointer  ${
              this.props.location.pathname === item.path
                ? "active"
                : ""
            }`}
            onMouseEnter={() => this.highlightMenu(item.id)}
            onMouseLeave={() => this.deHighlightMenu(item.id)}
            onPointerOver={() => this.highlightMenu(item.id)}

          >

<div className="profile-text firstImage" style={{textAlign:"center"}}>
  <img className="menu_item" style={{verticalAlign:"middle"}} height="28px" width="28px" src={`${FrontendUrl}${item.src}`} alt={item.name}/>
  <span style={{verticalAlign:"middle", width: "165px", fontSize: "20px", padding: "10px" }}  id={`${item.id}${isMObile}`}>{item.name}</span>
<hr className="menuBorder" style={{display: "none"}}/>
</div>            
          </div>
          : ""
          ));        
        }

      });
    } 
    return str;
  }

    

  render() {
    const { profileReducer, activeKey, mobileView, mobileClass, configReducer } = this.props;

    const { profileInfo } = profileReducer;
    const { configInfo } = configReducer;

    console.log("mobileView", mobileView);
    const immm = window.location.href;
    const samm = immm.split("/").splice(0, 3);
    const imgPath = FrontendUrl + "uploads/" + profileInfo.imagePath;
    console.log("dirrrrrrrrrrrrr", imgPath);
    logger(this.props.profileReducer);
    //console.log("config data",configInfo);
    //this.props.setUserImage(profileInfo.imagePath);

    return (
      <div>

        <div
          style={{display: "none" }} id="mobile-menu-hover-info"
          className={`menu-hover-info custom-sidebar menu-hover-info-hide ${
            mobileView ? mobileClass : ""
          }`} 
        >
          <div className="ITEMS_CONTAINER">
            <div className="cursor-pointer" style={{display:"flex",alignItems: "center"}}>
              <div className="profile-text firstImage" style={{textAlign: "center"}}>
                <img id="closeIconImg" className="menu_item" height="28px" width="28px" onClick={() => {
                              this.closeIcon();
                            }} src={closeIcon} style={{width:"100%",verticalAlign: "middle"}} alt="Home"  />
              </div>
            </div>
            {this.createMenus(configReducer, "mobile")}         
          </div>
          <div style={{height:"20px"}}></div>

        </div>  
      </div>
    );
  }
}

const mapStateToProps: any = (state: IRootState) => ({
  profileReducer: state.profileReducer,
  configReducer:state.configReducer,
});

export default connect(mapStateToProps)(MobileSidebar);
